const {KitModule, registerModule} = window;

import Swiper from 'swiper';
import {A11y, Navigation, Pagination} from 'swiper/modules';

class Carousel extends KitModule {
    constructor($element) {
        super($element);
        this.settings = this.$element.dataset.settings ? JSON.parse(this.$element.dataset.settings) : {};

        this.params = {
            modules: [A11y, Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                600: {
                    slidesPerView: 2,
                },
                960: {
                    slidesPerView: 2,
                },
                1280: {
                    slidesPerView: 4.5,
                },
                1440: {
                    slidesPerView: 4.5,
                },
            },
            grabCursor: true,
            pagination: {
                clickable: true,
                el: '.pagination__list',
                renderBullet: function(index, className) {
                    return `<button class="pagination__list-number type-eyebrow-1 ${className}">${index + 1}</button>`;
                },
            },
            navigation: {
                nextEl: '.next',
                prevEl: '.previous',
            },
        };

        const swiperEl = `#${this.$element.id}`;
        const swiperOptions = {...this.params, ...this.settings};

        /* eslint-disable */
        const swiper = new Swiper(swiperEl, swiperOptions);

        // Pause a slide's video as soon as it's no longer the active slide
        // (e.g. the centered video-testimonial carousel — scrolling past a
        // playing testimonial stops it).
        swiper.on('slideChange', () => {
            const activeSlide = swiper.slides[swiper.activeIndex];
            swiper.slides.forEach((slide) => {
                if (slide === activeSlide) return;
                slide.querySelectorAll('mux-player, video').forEach((media) => {
                    if (typeof media.pause === 'function' && !media.paused) media.pause();
                });
            });
        });
  }
}

registerModule('Carousel', Carousel);
